export default __webpack_public_path__ + "static/media/logo-simple.302336ee.svg";